import { Icon, LinkBox, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { NextLink } from '@src/components/sco/utilities/NextLink'
import React from 'react'
import { CgProfile } from 'react-icons/cg'
import { LuBadgeDollarSign, LuBook, LuCalendar, LuHand, LuUsers } from 'react-icons/lu'

const items = [
  {
    title: 'Post a Request',
    href: '/requests',
    icon: LuHand,
  },
  {
    title: 'Join an Event',
    href: '/events',
    icon: LuCalendar,
  },
  {
    title: 'Member Matching',
    href: '/members/matching',
    icon: LuUsers,
  },
  {
    title: 'Investor Matching',
    href: '/investors/matching',
    icon: LuBadgeDollarSign,
  },
  {
    title: 'Explore Courses',
    href: '/courses',
    icon: LuBook,
  },
  {
    title: 'Edit Profile',
    href: '/account/profile',
    icon: CgProfile,
  },
]

export const OnboardingQuickLinks = () => {
  const { getBreakpointValue } = useBreakpointContext()
  return (
    <SimpleGrid columns={getBreakpointValue([1, 3, 4, 6])} gap={[2, 2, 4]}>
      {items.map(item => (
        <LinkBox
          asChild
          bgColor={'colorPalette.container'}
          borderRadius={'lg'}
          boxShadow={'lg'}
          display={'block'}
          paddingX={'1em'}
          paddingY={'2em'}
          textAlign={'center'}
          transition={'all 150ms'}
          width={'full'}
          _hover={{
            bgColor: 'actionActiveSecondary',
            color: 'white',
          }}
        >
          <NextLink href={item.href}>
            <VStack gap={'1em'}>
              <Icon asChild boxSize={'1.5em'}>
                <item.icon />
              </Icon>
              <Text color={'white'} fontWeight={'bold'}>
                {item.title}
              </Text>
            </VStack>
          </NextLink>
        </LinkBox>
      ))}
    </SimpleGrid>
  )
}
